import * as React from 'react'
import { FC } from 'react'
import PageLayout from '../../components/page-layout/page-layout'

interface TechnicalCardsPageProps {}

const TechnicalCardsPage: FC<TechnicalCardsPageProps> = () => {
    return <PageLayout title={'Технические карты'}></PageLayout>
}

export default TechnicalCardsPage
